import React from "react"

const SelectSearchNotFound = props => {
    return (
        <span>Not Found</span>
    )
}

export default SelectSearchNotFound